import React from 'react';

function ITLabs() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#E4570B' }}>
      {/* Background pattern */}
      <div
        className="absolute inset-0 opacity-10 pointer-events-none"
        style={{
          backgroundImage: `
            linear-gradient(#6A310A 1px, transparent 1px),
            linear-gradient(90deg, #6A310A 1px, transparent 1px)
          `,
          backgroundSize: '40px 40px',
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-20">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h1
            className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-6"
            style={{
              color: '#DFC293',
              textShadow: '0 0 18px rgba(255,255,255,0.12), 0 0 30px rgba(223, 194, 147, 0.45)',
            }}
          >
            IT Labs
          </h1>
          <p
            className="text-xl sm:text-2xl max-w-3xl mx-auto"
            style={{ color: '#DFC293', opacity: 0.95 }}
          >
            Партнер на Futurathon 2025
          </p>
          <div style={{ marginTop: 18 }}>
            <a
              href="https://www.it-labs.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-3 rounded-lg font-semibold transition-all duration-200"
              style={{ backgroundColor: '#EFA74F', color: '#6A310A', boxShadow: '0 4px 12px rgba(239,167,79,0.25)', textDecoration: 'none' }}
            >
              Посети IT Labs
            </a>
          </div>
        </div>

        {/* Main Content - IT Labs Ethos and Details */}
        <div className="space-y-12">
          <div className="p-8 rounded-2xl border-2" style={{ backgroundColor: '#6A310A', borderColor: '#EFA74F', boxShadow: '0 8px 30px rgba(0,0,0,0.3)' }}>
            <h2 className="text-3xl font-bold mb-4" style={{ color: '#EFA74F' }}>Етос на IT Labs</h2>
            <div style={{ color: '#DFC293', lineHeight: 1.75 }}>
              <p className="text-lg md:text-xl">Добредојдовте во IT Labs. Нашата приказна започна во 2005 година во Лос Анџелес, Калифорнија, со едноставна, но моќна идеја: да создадеме тимови кои се извонредни во развојот на софтвер, не само така што прават работите правилно, туку и затоа што прават правилни работи. Веруваме дека користењето на најновите технологии не е само заради иновација, туку за да ги оснажиме нашите клиенти и да им помогнеме да бидат лидери во своите индустрии.</p>

              <p className="text-lg md:text-xl" style={{ marginTop: 12 }}><strong>Во срцето на IT Labs се нашите основни вредности:</strong> Интегритет, Изврсност, Проактивност, Иновација, Разновидност и непоколеблива посветеност кон нашите луѓе.</p>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="p-6 rounded-2xl border-2" style={{ backgroundColor: '#6A310A', borderColor: '#EFA74F' }}>
                <h3 className="text-2xl md:text-3xl font-bold mb-3" style={{ color: '#EFA74F' }}>Мисија</h3>
                <p className="text-lg md:text-xl" style={{ color: '#DFC293', lineHeight: 1.6 }}>Нашата мисија е да ја искористиме трансформативната моќ на технологијата за да ги оснажиме бизнисите. Се посветуваме на креирање прилагодени софтверски решенија кои не само што ги решаваат сегашните предизвици, туку и ги предвидуваат потребите на иднината.</p>
            </div>

            <div className="p-6 rounded-2xl border-2" style={{ backgroundColor: '#6A310A', borderColor: '#EFA74F' }}>
              <h3 className="text-2xl md:text-3xl font-bold mb-3" style={{ color: '#EFA74F' }}>Визија</h3>
              <p className="text-lg md:text-xl" style={{ color: '#DFC293', lineHeight: 1.6 }}>Нашата визија е да бидеме на чело на индустријата за технолошки услуги, водени од иновација, интегритет и длабока посветеност на растот на нашите клиенти.</p>
            </div>

            <div className="p-6 rounded-2xl border-2" style={{ backgroundColor: '#6A310A', borderColor: '#EFA74F' }}>
              <h3 className="text-2xl md:text-3xl font-bold mb-3" style={{ color: '#EFA74F' }}>Цел</h3>
              <p className="text-lg md:text-xl" style={{ color: '#DFC293', lineHeight: 1.6 }}>Да им помогнеме на луѓето да се развиваат — било да се дел од нашите тимови или да работат во компании за кои нудиме решенија. Преку менторство и обуки, се стремиме да им помогнеме на луѓето да растат и да станат примерни професионалци во технолошкиот свет.</p>
            </div>
          </div>

          

          <div className="p-8 rounded-2xl border-2" style={{ backgroundColor: '#6A310A', borderColor: '#749269' }}>
            <h3 className="text-3xl font-bold mb-4" style={{ color: '#EFA74F' }}>Нашите вредности</h3>
            <div style={{ color: '#DFC293', lineHeight: 1.8 }}>
              <h4 style={{ color: '#EFA74F', marginBottom: 6 }}>Интегритет</h4>
              <p className="text-lg md:text-xl">Повеќе од само принцип — тоа е нашиот начин на живеење. Ние стоиме зад нашите зборови и постапки и градиме доверба преку транспарентност.</p>

              <h4 style={{ color: '#EFA74F', marginTop: 12, marginBottom: 6 }}>Разновидност</h4>
              <p className="text-lg md:text-xl">Со 65% од тимот и 95% од раководството составено од жени, ние поставуваме стандарди за разновидност и инклузија во индустријата.</p>

              <h4 style={{ color: '#EFA74F', marginTop: 12, marginBottom: 6 }}>Изврсност</h4>
              <p className="text-lg md:text-xl">Изврсноста не е само цел; таа е непрекинат пат кон подобрување и испорачување на највисок квалитет во сè што правиме.</p>

              <h4 style={{ color: '#EFA74F', marginTop: 12, marginBottom: 6 }}>Проактивност и Иновација</h4>
              <p className="text-lg md:text-xl">Го поттикнуваме преземањето иницијатива, меритократијата на идеите и пристапот кој ја избира вистинската технологија за секој проект.</p>

              <h4 style={{ color: '#EFA74F', marginTop: 12, marginBottom: 6 }}>Луѓе</h4>
              <p className="text-lg md:text-xl">Луѓето се срцето на IT Labs. Ги почитуваме различностите и создававме можности за раст, менторство и меѓународно искуство.</p>
            </div>
          </div>

          <div className="p-8 rounded-2xl border-2" style={{ backgroundColor: '#6A310A', borderColor: '#EFA74F' }}>
            <h3 className="text-3xl font-bold mb-4" style={{ color: '#EFA74F' }}>Развој и негување на таленти</h3>
            <p className="text-lg md:text-xl" style={{ color: '#DFC293', lineHeight: 1.6 }}>Во IT Labs, негувањето на талентите е интегрален дел од нашиот етос. Започнуваме со длабински процени на перформансите и градиме персонализирани планови за развој поддржани со менторство, коучинг и програми за обука.</p>
          </div>

          <div className="p-8 rounded-2xl border-2" style={{ backgroundColor: '#6A310A', borderColor: '#EFA74F' }}>
            <h3 className="text-3xl font-bold mb-4" style={{ color: '#EFA74F' }}>Општествена одговорност и ангажман</h3>
            <p className="text-lg md:text-xl" style={{ color: '#DFC293', lineHeight: 1.6 }}>IT Labs поддржува хуманитарни иницијативи и придонесува во технолошката заедница преку споделување на знаење, на пример преку иницијативи како "CTO Confessions Podcast".</p>
          </div>

          <div className="p-8 rounded-2xl border-2 text-center" style={{ backgroundColor: '#6A310A', borderColor: '#EFA74F' }}>
            <h3 className="text-3xl font-bold mb-4" style={{ color: '#EFA74F' }}>Поглед кон иднината</h3>
            <p className="text-lg md:text-xl" style={{ color: '#DFC293', lineHeight: 1.6 }}>Во иднина, IT Labs ќе продолжи да биде на чело на технолошките иновации. Истражуваме нови услуги како FPGA, им помагаме на клиентите да се подготват за регулативи како NIS2 и обучуваме луѓе за нови кариери во технологијата преку Growth Labs Academy.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ITLabs;
